import React from 'react';
import { batch } from 'react-redux';
import BaseApp from '../../../base/app/components/BaseApp';
import { setConfig } from '../../../base/config/actions';
import { createPrejoinTracks } from '../../../base/tracks/functions.web';
import GlobalStyles from '../../../base/ui/components/GlobalStyles.web';
import JitsiThemeProvider from '../../../base/ui/components/JitsiThemeProvider.web';
import DialogContainer from '../../../base/ui/components/web/DialogContainer';
import { setupInitialDevices } from '../../../conference/actions.web';
import { getPersistentItem } from '../../../vrs-auth/storage';
import { initPrejoin } from '../../actions.web';
import PrejoinThirdParty from './PrejoinThirdParty';
import Prejoin from './Prejoin';
/**
 * Wrapper application for prejoin.
 *
 * @augments BaseApp
 */
export default class PrejoinApp extends BaseApp {
    /**
     * Navigates to {@link Prejoin} upon mount.
     *
     * @returns {void}
     */
    async componentDidMount() {
        await super.componentDidMount();
        const { store } = this.state;
        const { dispatch } = store ?? {};
        const { styleType } = this.props;
        // Check if this is a VRS user (has role parameter)
        const urlParams = new URLSearchParams(window.location.search);
        const hasVRSRole = urlParams.has('role');
        const host = window.location.hostname.toLowerCase();
        const isVriHost = host.startsWith('vri.')
            || host.startsWith('staging-vri.')
            || host.includes('maplecomm.ca');
        const hasVriAuth = getPersistentItem('vrs_client_auth') === 'true'
            || getPersistentItem('vrs_user_role') === 'client'
            || Boolean(getPersistentItem('vrs_auth_token'));
        const shouldSuppressPreAuthVideo = isVriHost && !hasVriAuth;
        super._navigate({
            component: hasVRSRole ? Prejoin : PrejoinThirdParty,
            props: {
                className: styleType
            }
        });
        const { startWithAudioMuted, startWithVideoMuted } = store
            ? store.getState()['features/base/settings']
            : { startWithAudioMuted: undefined,
                startWithVideoMuted: undefined };
        dispatch?.(setConfig({
            prejoinConfig: {
                enabled: true
            },
            startWithAudioMuted,
            startWithVideoMuted: shouldSuppressPreAuthVideo ? true : startWithVideoMuted
        }));
        await dispatch?.(setupInitialDevices());
        const { tryCreateLocalTracks, errors } = createPrejoinTracks({
            forceStartWithVideoMuted: shouldSuppressPreAuthVideo
        });
        const tracks = await tryCreateLocalTracks;
        batch(() => {
            dispatch?.(initPrejoin(tracks, errors));
        });
    }
    /**
     * Overrides the parent method to inject {@link AtlasKitThemeProvider} as
     * the top most component.
     *
     * @override
     */
    _createMainElement(component, props) {
        return (React.createElement(JitsiThemeProvider, null,
            React.createElement(GlobalStyles, null),
            super._createMainElement(component, props)));
    }
    /**
     * Renders the platform specific dialog container.
     *
     * @returns {React$Element}
     */
    _renderDialogContainer() {
        return (React.createElement(JitsiThemeProvider, null,
            React.createElement(DialogContainer, null)));
    }
}
